import React from 'react';
import { ArrowUp } from 'lucide-react';
import HeroSection from '../components/sections/HeroSection';
import SkillsSection from '../components/sections/SkillsSection';
import FeaturedProjects from '../components/sections/FeaturedProjects';
import ResearchSection from '../components/sections/ResearchSection';
import ThreeSection from '../components/sections/ThreeSection';

const Home: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="min-h-screen">
      <HeroSection />
      <SkillsSection />
      <ResearchSection />
      <FeaturedProjects />
      <ThreeSection />
      
      {/* Call to Action */}
      <section className="bg-gradient-to-br from-primary-50/80 via-white/40 to-primary-100/60 backdrop-blur-sm section-padding">
        <div className="container-max text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-secondary-900 mb-6">
            That&apos;s all for now
          </h2>
          <p className="text-xl mb-8 text-secondary-600 max-w-2xl mx-auto">
            Thanks for stopping by!
          </p>
          <p className="text-lg mb-8 text-secondary-500 font-handwritten max-w-2xl mx-auto">
            (press space to jump)
          </p>
          <button
            onClick={scrollToTop}
            className="inline-flex items-center bg-primary-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-primary-700 transition-colors duration-200"
          >
            Back to Top
            <ArrowUp className="ml-2 h-5 w-5" />
          </button>
        </div>
      </section>
    </div>
  );
};

export default Home; 